import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { trigger, transition, style, animate, query, stagger } from '@angular/animations';
import { WebStatusService, WebStatus } from '../../../shared/services/web-status.service';

@Component({
  selector: 'app-stats-section',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterModule],
  templateUrl: './stats-section.component.html',
  styleUrl: './stats-section.component.scss',
  host: { id: 'stats-section' },
  animations: [
    trigger('fadeInScale', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.95)' }),
        animate('800ms ease-out', style({ opacity: 1, transform: 'scale(1)' }))
      ])
    ]),
    trigger('staggerStats', [
      transition('* => *', [
        query(':enter', [
          style({ opacity: 0, transform: 'translateY(20px)' }),
          stagger('200ms', [
            animate('600ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
          ])
        ], { optional: true })
      ])
    ]),
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('600ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ])
  ]
})
export class StatsSectionComponent implements OnInit {
  webStatus: WebStatus | null = null;
  loading = true;
  error = false;
  revenueDescription: string = '';

  constructor(
    private webStatusService: WebStatusService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.fetchWebStatus();

    // Subscribe to language changes
    this.translateService.onLangChange.subscribe(() => {
      this.updateRevenueDescription();
    });
  }

  fetchWebStatus(): void {
    this.webStatusService.getWebStatus().subscribe({
      next: (data) => {
        this.webStatus = data;
        this.loading = false;
        this.updateRevenueDescription();
      },
      error: (err) => {
        console.error('Error fetching web status:', err);
        this.error = true;
        this.loading = false;
      }
    });
  }

  updateRevenueDescription(): void {
    if (this.webStatus) {
      const formattedAmount = this.formatBillions(this.webStatus.transactionsAmount);
      this.translateService.get('home.stats-section.stats.1.description', { value: formattedAmount })
        .subscribe((res: string) => {
          this.revenueDescription = res;
        });
    } else {
      this.revenueDescription = '';
    }
  }

  // Format large numbers with commas
  formatNumber(num: number): string {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // Format currency in billions
  formatBillions(amount: number): string {
    return `${amount.toLocaleString()} OMR`;
  }
}
